import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/scrollbar';
import html2Element from '../utils/html2Element';

export default function (element, data) {
    const years = data.years;
    const yearsElement = element.querySelector(".years");
    const navigation = element.querySelector(".navigation");

    years.forEach(year => {
        const yearElement = html2Element(`<button type="year" class="year-button year-button-${year}">${year}</button>`);

        yearElement.addEventListener("click", function () {
            setYear(year);
        });
        
        yearsElement.append(yearElement);
    });

    const swiper = new Swiper(element.querySelector(".swiper"), {
        modules: [Navigation, Scrollbar],
        slidesPerView: 1,
        speed: 300,
        spaceBetween: 40,
        scrollbar: {
            el: element.querySelector(".swiper-scrollbar"),
            draggable: true,
        },
        navigation: {
            nextEl: element.querySelector(".swiper-button-next"),
            prevEl: element.querySelector(".swiper-button-prev"),
        },

        breakpoints: {
            550: {
                slidesPerView: 2,
            },
            800: {
                slidesPerView: 3,
            },
            1000: {
              slidesPerView: 4,
            }
          }
    });

    function setYear(year) {
        yearsElement.querySelectorAll(".year-button").forEach(function (btn) {
            btn.classList.remove("current");
        });

        yearsElement.querySelectorAll(".year-button-" + year).forEach(function (btn) {
            btn.classList.add("current");
        });

        element.querySelectorAll(".switchable").forEach(function (tile) { tile.style.display = "none"; });
        element.querySelectorAll(".switchable-year-" + year).forEach(function (tile) { tile.style.display = "block"; });

        swiper.update();

        if (swiper.isBeginning && swiper.isEnd) {
            element.querySelector(".swiper").classList.add("no-navigation");
            navigation.style.visibility = "hidden";
        } else {
            element.querySelector(".swiper").classList.remove("no-navigation");
            navigation.style.visibility = "visible";
        }
    }

    setTimeout(function () {
        setYear(years[0]);
    }, 100);
};

// @widgetLoadingMode:lazy-once